import isNullOrUndefined from "_shared/_utilities/is-null-or-undefined";
import BillingRateInfoSchema, {
  BillingRateInfoJSON,
  BillingRateInfoParams,
} from "marketplace/teams/fee-schedules/rates/billing-rate-info-schema";

export default class BillingRateInfo {
  public static get EXAMPLE(): BillingRateInfo {
    return new BillingRateInfo({
      billingRate: "150.00",
      billingUnit: "hour",
    });
  }

  public static create(values: BillingRateInfoParams): BillingRateInfo {
    const parsed = BillingRateInfoSchema.validate(values);
    if (isNullOrUndefined(parsed)) {
      throw new Error("Invalid BillingRateInfo parameters.");
    }
    return new BillingRateInfo(parsed);
  }

  public static fromJSON(json: unknown): BillingRateInfo | null | undefined {
    if (isNullOrUndefined(json)) return json;
    const params = BillingRateInfoSchema.deserialize(json);
    return new BillingRateInfo(params);
  }

  public readonly billingRate: string;
  public readonly billingUnit?: string;

  public constructor(params: BillingRateInfoParams) {
    this.billingRate = params.billingRate;
    this.billingUnit = params.billingUnit;
  }

  public toJSON(): BillingRateInfoJSON {
    return BillingRateInfoSchema.serialize(this);
  }

  public isEqualTo(other: BillingRateInfo | null | undefined): boolean {
    if (!other) return false;
    return this.billingRate === other.billingRate && this.billingUnit === other.billingUnit;
  }

  public toString(): string {
    return `${this.billingRate} per ${this.billingUnit}`;
  }
}
